import React from 'react';
import {observer} from 'mobx-react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {rootStore} from '../../stores/rootStore';
import {navigateToGiftCardsShop} from '../../utils/giftCards';

enum CardOptions {
  BUY_A_GIFT_CARD = 'Buy a Gift Card',
  PARTICIPATING_STORES = 'Gift Card - Participating Stores',
  CHECK_A_GIFT_CARD_BALANCE = 'Check a Gift Card Balance',
  HOW_TO_REDEEM_A_GIFT_CARD = 'How to Redeem a Gift Card',
  TERMS_AND_CONDITIONS = 'Terms and Conditions',
}

// `isSelectedStoreGiftCardStore` is read off the MobX root store during render.
const GiftCardsOptionsScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_OPTIONS>) => {
    const isGiftCardStore = rootStore.shopSelectionStore?.isSelectedStoreGiftCardStore;

    const handleMenuItemPress = (item: {id: CardOptions; name: string}) => {
      switch (item.id) {
        case CardOptions.BUY_A_GIFT_CARD:
          if (isGiftCardStore) {
            navigation.navigate(AppRoute.GIFT_CARDS_MAIN);
          } else {
            navigateToGiftCardsShop(rootStore);
          }
          break;
        case CardOptions.PARTICIPATING_STORES:
          // Dedicated screen renders the store-locator widget directly, so it works in
          // every navigator (including the gift card store, whose navigator excludes
          // AppRoute.PROMOTION). No store-type branch needed.
          navigation.navigate(AppRoute.GIFT_CARDS_PARTICIPATING_STORES);
          break;
        case CardOptions.CHECK_A_GIFT_CARD_BALANCE:
          navigation.navigate(AppRoute.GIFT_CARDS_CHECK_BALANCE);
          break;
        case CardOptions.HOW_TO_REDEEM_A_GIFT_CARD:
          navigation.navigate(AppRoute.GIFT_CARDS_HOW_TO_REDEEM);
          break;
        case CardOptions.TERMS_AND_CONDITIONS:
          navigation.navigate(AppRoute.GIFT_CARDS_TERMS_AND_CONDITIONS);
          break;
        default:
          break;
      }
    };

    const menuItems = [
      {id: CardOptions.BUY_A_GIFT_CARD, name: 'Buy a Gift Card'},
      {
        id: CardOptions.PARTICIPATING_STORES,
        name: 'Gift Card - Participating Stores',
      },
      {
        id: CardOptions.CHECK_A_GIFT_CARD_BALANCE,
        name: 'Check a Gift Card Balance',
      },
      {
        id: CardOptions.HOW_TO_REDEEM_A_GIFT_CARD,
        name: 'How to Redeem a Gift Card',
      },
      {
        id: CardOptions.TERMS_AND_CONDITIONS,
        name: 'Terms and Conditions',
      },
    ];

    return (
      <ContentView testID="information-screen">
        <FlatListMenu data={menuItems} onPressItem={handleMenuItemPress} />
      </ContentView>
    );
  },
);

export default GiftCardsOptionsScreen;
